<template>
  <p class="text-base font-primary">
    <!-- mt-4 text-md lg:text-lg tracking-tight -->
    <slot />
  </p>
</template>
